import { cn } from "@/lib/utils";
import { LandingCopyBoundary } from "./lib/copy";
import { GrainLowOverlay } from "./lib/grain-low-overlay";
import { GREIGE_GRAIN_SURFACE_CLASS } from "./lib/greige-grain-surface";
import { hostNavHeightStyle, useHostNavHeight } from "./lib/use-host-nav-height";
import { SectionFour } from "./sections/four/section-four";
import { SectionOne } from "./sections/one/section-one";
import { SectionThree } from "./sections/three/section-three";
import { SectionTwo } from "./sections/two/section-two";

export interface LandingPageProps {
	className?: string;
}

export function LandingPage({ className }: LandingPageProps) {
	return (
		<LandingCopyBoundary>
			<LandingPageContent className={className} />
		</LandingCopyBoundary>
	);
}

/**
 * Stacked document flow. Each section is a normal-flow block; the greige-400 + grain paper
 * lives on the root so S1/S2 share it, while S3 + S4 paint their own image backgrounds.
 * S3 is the pinned landscape/chat world (its own scroll slice); S4 slides over it.
 */
function LandingPageContent({ className }: LandingPageProps) {
	const navHeight = useHostNavHeight();
	return (
		<div
			className={cn(GREIGE_GRAIN_SURFACE_CLASS, "font-sans text-teal-500", className)}
			data-webflow-component="landing-page"
			style={hostNavHeightStyle(navHeight)}
		>
			<GrainLowOverlay />
			<SectionOne />
			<SectionTwo />
			<SectionThree />
			<SectionFour />
		</div>
	);
}
